import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { extractError } from '@iso/lib/helpers/api';
import GroupService from '@iso/services/AccountService/GroupService';
import { types, actions } from './reducer';

function* deleteGroup({ id }) {
    try {
        yield call(GroupService.deleteOne, id);
        yield put(actions.deleteGroupSucceeded(id));
    } catch (error) {
        yield put(actions.deleteGroupFailed(extractError(error)));
    }
}

function* watchDeleteGroup() {
    yield takeEvery(
        types.REQUEST_DELETE_GROUP,
        deleteGroup,
    );
}

function* deleteSaga() {
    yield all([
        fork(watchDeleteGroup),
    ]);
}

export default deleteSaga;
